/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PropTypes from 'prop-types'
import { Carousel, Image, Row, Col, Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMessage,
  faShareFromSquare,
  faThumbsUp,
} from '@fortawesome/free-regular-svg-icons'
import { faImage, faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function SocialPostPreview({ srcs, title, text, likes, comments, shares }) {
  const validImages = Array.isArray(srcs) ? srcs.filter((src) => src.file) : []

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="border-bottom mb-3 d-flex"
          style={{ width: '240px', height: '55px', zIndex: '0' }}
        >
          <div className="w-80 m-auto ms-auto">
            <Image src={wavenet_logo} className="w-75 ps-3" />
          </div>
          <div className="w-20 m-auto ms-auto d-flex">
            <FontAwesomeIcon icon={faBars} className="text-end" />
          </div>
        </div>
        <div className="text-title" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-ban1" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line2" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <div
        className="w-100 px-2 mt-2 text-start"
        style={{
          fontSize: '0.8rem',
          fontWeight: 'bold',
          borderRadius: '5px 5px 0px 0px ',
          border: '1px solid #eee',
          background: '#ddd',
        }}
      >
        {title?.trim() ? title : '社群貼文標題預覽'}
      </div>

      {validImages.length === 0 ? (
        <div
          style={{ fontSize: '0.8rem' }}
          className="w-100 text-center p-3 border text-secondary"
        >
          <FontAwesomeIcon icon={faImage} />
          &ensp;請上傳圖片
        </div>
      ) : (
        <Carousel className="w-100 mx-auto border">
          {validImages.map((src, idx) => {
            let imageSrc
            if (src.file instanceof File) {
              imageSrc = URL.createObjectURL(src.file)
            } else if (
              typeof src.file === 'string' &&
              src.file.startsWith('blob:')
            ) {
              imageSrc = src.file
            } else {
              imageSrc = `/api/file/${src.file}`
            }
            return (
              <Carousel.Item key={idx}>
                <img
                  className="d-flex w-100"
                  src={imageSrc}
                  alt={src.label}
                  style={{ objectFit: 'cover', height: '20%' }}
                />
                <CIIcon />
              </Carousel.Item>
            )
          })}
        </Carousel>
      )}

      <div
        className="w-100 p-2 mb-0 text-start"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          fontSize: '0.7rem',
          fontWeight: '400',
          borderRadius: '0px',
          border: '1px solid #ddd',
          borderTop: 'none',
          textAlign: 'start',
        }}
      >
        {text?.trim()
          ? text
          : 'Hi～這是一篇社群貼文預覽，如此處的預設值，能夠顯示任何你在左方輸入的文字或符號，可以輸入自己想要的內容，都會顯示在這裡🥳...more'}
      </div>

      <div
        className="w-100 px-2 text-center"
        style={{
          backgroundColor: '#ddd',
          fontSize: '0.8rem',
          fontWeight: 'bold',
          borderRadius: '0px',
          border: '1px solid #ddd',
          paddingRight: '0',
        }}
      >
        <div className="d-flex">
          <Badge className="w-25 ms-auto" bg="primary">
            立即前往
          </Badge>
        </div>
      </div>

      <Row
        className="text-center mx-0"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          fontSize: '0.8rem',
          borderRadius: '0px',
          border: '1px solid #ddd',
        }}
      >
        <Col xs={4} className="d-flex text-secondary overflow-hidden">
          <FontAwesomeIcon icon={faThumbsUp} className="pe-1 my-auto" />
          {likes || '0'}
        </Col>
        <Col xs={4} className="d-flex text-secondary overflow-hidden">
          <FontAwesomeIcon icon={faMessage} className="pe-1 my-auto" />
          {comments || '0'}
        </Col>
        <Col xs={4} className="d-flex text-secondary overflow-hidden">
          <FontAwesomeIcon icon={faShareFromSquare} className="pe-1 my-auto" />
          {shares || '0'}
        </Col>
      </Row>

      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>
    </div>
  )
}

SocialPostPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  title: PropTypes.string,
  text: PropTypes.string,
  likes: PropTypes.string,
  comments: PropTypes.string,
  shares: PropTypes.string,
}

SocialPostPreview.defaultProps = {
  srcs: [],
  title: '',
  text: '',
  likes: '0',
  comments: '0',
  shares: '0',
}

export default SocialPostPreview
